import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as core from '../../core'

import { JobTitle } from './job-title'
import type { Organization } from './organizations'
import type { RoomType } from './room-type'

export type Employee = Employee.Basic & {
  organization: Organization.Reference
  jobTitleId?: JobTitle.Id
}

export namespace Employee {
  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export type Input = Pick<Employee, 'name' | 'organization' | 'jobTitleId'>

  export type Basic = core.common.Identified<Employee.Id> &
    core.common.Named &
    core.common.Described.Optionally &
    core.common.Coded

  export interface Filter {
    jobTitleId?: JobTitle.Id
    name?: string
    orgFilter?: Filter.OrgFilter
    search?: string
    isOccupant?: boolean
    isSponsored?: boolean
  }
  export namespace Filter {
    export interface OrgFilter {
      entityId: core.dms.models.Entity.Id
      recordIds: readonly core.dms.data.Record.Id[]
    }
    export namespace OrgFilter {
      export const isOrgFilter: TypeChecker<OrgFilter> =
        TypeChecker.Factory.object({
          entityId: core.dms.models.Entity.Id.isId,
          recordIds: TypeChecker.Factory.list(core.dms.data.Record.Id.isId),
        })
      export const assertIsOrgFilter: TypeAsserter<OrgFilter> =
        TypeAsserter.Factory.from(isOrgFilter)
    }

    export const isFilter: TypeChecker<Filter> = TypeChecker.Factory.object({
      jobTitleId: TypeChecker.Factory.optional(JobTitle.Id.isId),
      name: TypeChecker.Factory.optional(TypeChecker.isString),
      orgFilter: TypeChecker.Factory.optional(OrgFilter.isOrgFilter),
      search: TypeChecker.Factory.optional(TypeChecker.isString),
    })
    export const assertIsFilter: TypeAsserter<Filter> =
      TypeAsserter.Factory.from(isFilter)
  }

  export type WithSpaceRecords = Employee.Basic & {
    spaceRecords: {
      details: DetailsLookup
      roomType: RoomType
      organization: DetailsLookup
    }[]
  }

  export type DetailsLookup = globalThis.Record<
    core.dms.models.Entity.Id,
    core.common.Identified<core.dms.data.Record.Id> &
      core.common.Named &
      core.common.Described.Optionally &
      core.common.Coded
  >
}
